import { render, staticRenderFns } from "./UserVacation.vue?vue&type=template&id=36d0d3bc"
import script from "./UserVacation.vue?vue&type=script&lang=js"
export * from "./UserVacation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports